import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const SetBallPopup = new PopupBuilder('Set ball', {
  incident_id: VolleyballIncidentId.SetBall,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
